export const typeInBR:any = {
    water: 'Água',
    fire: 'Fogo',
    normal: 'Normal',
    fighting: 'Lutador',
    flying: 'Voador',
    grass: 'Planta',
    dragon: 'Dragão',
    ice: 'Gelo',
    poison: 'Tóxico',
    ground: 'Terra',
    electric: 'Elétrico',
    fairy: 'Fada',
    steel: 'Aço',
    dark: 'Sombrio',
    ghost: 'Fantasma',
    rock: 'Pedra',
    bug: 'Inseto',
    psychic: 'Psíquico'
}